import {DOM, ENodeType} from "lib/commons/xml/dom";
import {IJmlObj, IJmlSet, IJmlSubSet, JML, JmlSubSetIterator} from "lib/commons/xml/jml";
import {XA} from "lib/commons/xml/xAddr";
import {XmlBatch, XmlDeleteMsg, XmlInsertMsg, XmlStrMsg} from "lib/edit/ot/xmlHouse";
import {CARD, ECard, EPastePos, IImportPos, SchemaDom, SkContext, SkNode} from "lib/edit/schema/schema";
import {EAnnotLevel, EDirectiveType, EFuzzyType, ISkAnnot, ISkStructDef, SkAnnotStr, SkAnnotWrongValue} from "lib/edit/schema/schemaAnnots";
import {SK_NS} from "lib/edit/schema/schemaBuilder";
import {
	EGramLevelType,
	ISkImporter,
	ISkMetaNode,
	OSkImportCtxInternal,
	OSkImportDatas,
	OSkPasteContext,
	SkImpBase,
	SkImpGoUp,
	SkImpSimple,
	SkMBase,
	SkMCompo,
	SKMETA,
	SkMetaLib,
	SKMETALIB,
	SkMField,
	SkMObject,
	SkMPart
} from "lib/edit/schema/schemaMeta";
import {ISkMInText, SkMPara} from "lib/edit/schema/schemaMetaTxt";
import {ISkRuleObj, SkRule, SkRuleAttr, SkRuleElt, SkRuleNode} from "lib/edit/schema/schemaPatterns";
import {IShortDescsTransfer, IShortDescTransfer, IShortDescUrlTransfer, isShortDescsTransfer, ITEM, OImportInterWspOptions, ShortDescsFromUrlList, srcRefSub} from "lib/wsp/item";
import {JSrcFields, JSubItem, SRC, srcRef} from "lib/wsp/src";
import {IWspEnv, WSP, Wsp} from "lib/wsp/wsp";
import {IWspXmlHouse} from "lib/wsp/wspsLive";
import {EItemTypeFamily, ItemType} from "lib/wsp/wspMetaUi";
import {IReg} from "lib/commons/registry";
import {SkMSpTeCompo, SkMSpTeCompoRoot, SkMSpTeSegment} from "lib/edit/schema/schemaMetaSpTe";
import {LANG} from "lib/commons/lang";
import {ISchemaSearch, SkSearchNodeAnnot} from "lib/edit/schema/schemaSearch";
import {CONVERTERLIB, IConvertDst, IConverter, IConvertSrc} from "lib/edit/import/convert";
import {WspXmlHouse} from "lib/wsp/wspHouse";
import {REMOTE} from "lib/core/remote";
import IS_element = DOM.IS_element;
import ctxLastSkRule = SKMETA.ctxLastSkRule;


export const SKMETALIB_WSP = new SkMetaLib(SKMETALIB);


class SkMCompoWsp extends SkMCompo {

	_pushLinksImporters<L>(results: ISkImporter[], compoRule: SkRuleNode, pos: EPastePos | IImportPos, ctx: OSkImportCtxInternal, linksInfo: L, cache: OSkImportDatas) {
		if (!isShortDescsTransfer(linksInfo)) return;
		const modelName = getModelName(compoRule);
		const offset = linksInfo.shortDescs.findIndex((s) => s?.itModel === modelName);
		if (offset >= 0) results.push(new SkImpInternalize(ctx, linksInfo, offset, pos));
		//console.log("SkMCompoWsp::", compoRule, linksInfo);
	}
}

SKMETALIB_WSP.registerMetaNode(new SkMCompoWsp('Compo'));

/** SpTeCompoRoot*/
class SkMSpTeCompoRootWsp extends SkMSpTeCompoRoot {
}

LANG.completeClassProps(SkMCompoWsp, SkMSpTeCompoRootWsp);

SKMETALIB_WSP.registerMetaNode(new SkMSpTeCompoRootWsp('SpTeCompoRoot'));

/** SpTeCompo */
class SkMSpTeCompoWsp extends SkMSpTeCompo {
}

LANG.completeClassProps(SkMCompoWsp, SkMSpTeCompoWsp);

SKMETALIB_WSP.registerMetaNode(new SkMSpTeCompoWsp('SpTeCompo'));

/** Attribut sc:refUri */
class SkMPtrItem extends SkMBase {

	/** null pas d'annot à afficher. */
	static buildAnnot(attr: Attr, rule: IPtrItemRule): ISkAnnot | null {
		const map = (attr.ownerDocument as IDocumentInWspHouse).srcRefMap;
		if (map) {
			const srcRefSub: srcRefSub = attr.nodeValue;
			const subId = ITEM.extractSubItemId(srcRefSub);
			const srcRef: srcRef = subId ? ITEM.extractSrcRef(srcRefSub, subId) : srcRefSub;
			const shortDesc = map.get(srcRef);
			if (shortDesc === undefined) {
				//fetch needed
				return new SkAnnotFutureLink().init(attr, rule);
			} else if (shortDesc === null) {
				return new SkAnnotWrongValue().init(attr, "Item manquant");
			} else if (shortDesc instanceof Promise) {
				return new SkAnnotFutureLink().init(attr, rule, shortDesc);
			} else if (subId) {
				const subItem = ITEM.findSubItem(subId, shortDesc.itSubItems);
				if (subItem === undefined) {
					return new SkAnnotWrongValue().init(attr, "Le fragment référencé dans cet item n'existe pas");
				} else if (!rule.subItSgnPattern) {
					return new SkAnnotWrongValue().init(attr, "Référencer un fragment n'est pas autorisé ici");
				} else if (!subSgnMatch(subItem, rule.subItSgnPattern)) {
					return new SkAnnotWrongValue().init(attr, "Ce type de fragment d'item n'est pas autorisé ici");
				}
			} else if (!sgnMatch(shortDesc, rule.itSgnPattern)) {
				return new SkAnnotWrongValue().init(attr, "Type d'item non autorisé");
			} else if (!sgnMatch(shortDesc, rule.subItSgnPattern)) {
				//Pas de subItem pointé, mais subItem Sgn déclaré qui ne match pas la racine
				return new SkAnnotWrongValue().init(attr, "Cet item ne correspond pas au type de fragment autorisé ici");
			}
		}
		return null;
	}

	get gramLevelType(): EGramLevelType {return EGramLevelType.undef}

	initSkRule(skRule: IPtrItemRule, confRule: Element): void {
		const sgnPattern = confRule.getAttributeNS(SK_NS, "sgn");
		if (sgnPattern) skRule.itSgnPattern = new RegExp(sgnPattern);
		const subPattern = confRule.getAttributeNS(SK_NS, "subPattern");
		if (subPattern) skRule.subItSgnPattern = new RegExp(subPattern);
		//console.log("initSkRule:::::sgnPattern:", sgnPattern);
	}

	async tryPasteNodes(ctx: OSkImportCtxInternal, content: Node, cache: OSkImportDatas): Promise<ISkImporter[]> {
		if (content.localName === 'fragment' && content.namespaceURI === DOM.SCCORE_NS) {
			const elt = DOM.findFirstChild(content, DOM.IS_element);
			const refUri = elt.getAttributeNS(DOM.SCCORE_NS, "refUri");
			if (refUri) {
				const wsp = (ctx.schemaDom.document as IDocumentInWspHouse).wsp;
				if (wsp) {
					const sd = await wsp.fetchShortDesc(refUri);
					const linksInfo: IShortDescsTransfer = {
						sdTrsfId: "x",
						wsp,
						shortDescs: [sd]
					};
					return this.tryPasteLinks(ctx, linksInfo, cache);
				}
			}
		}
		return null;
	}

	tryPasteText(ctx: OSkImportCtxInternal, text: string, cache: OSkImportDatas): Promise<ISkImporter[]> {
		//Si on n'est pas en mode preserveUnknown (édition XML avec erreurs), on n'autorise pas de coller un lien issu d'un texte simple.
		return ctx.preserveUnknown ? super.tryPasteText(ctx, text, cache) : null;
	}

	async tryPasteLinks<L>(ctx: OSkImportCtxInternal, linksInfo: L, cache: OSkImportDatas): Promise<ISkImporter[]> {
		if (isShortDescsTransfer(linksInfo)) {
			//console.log("tryPasteLinks::::::", linksInfo);
			const rule = SKMETA.ctxLastSkRule(ctx) as IPtrItemRule;
			// Retourne un tableau vide si aucun lien compatible pour bloquer d'autres tentatives d'import dégradés.
			if (linksInfo.isImportUrls) return rule.itSgnPattern?.source.indexOf("RemoteBinary") < 0 ? [] : [new SkImpSrcUri(ctx, rule, linksInfo, 0)];
			if (linksInfo.isImport) return [new SkImpSrcUri(ctx, rule, linksInfo, 0)];
			const offset = linksInfo.shortDescs.findIndex((shortDesc: JSrcFields) => shortDesc && (ctx.preserveUnknown || (sgnMatch(shortDesc, rule.itSgnPattern) && subSgnMatch(shortDesc.itSubItem || shortDesc, rule.subItSgnPattern))));
			return offset >= 0 ? [new SkImpSrcUri(ctx, rule, linksInfo, offset)] : [];
		}
		return null;
	}

	async tryImportLinks<L>(ctx: OSkImportCtxInternal, linksInfo: L, cache: OSkImportDatas): Promise<ISkImporter[]> {
		return this.tryPasteLinks(ctx, linksInfo, cache);
	}

	onExecRules(skCtx: SkContext, rule: IPtrItemRule, attr: Attr): void {
		if (skCtx.execOptions.genAnnots) {
			//Validation du lien
			if (attr.nodeValue) {
				const annot = SkMPtrItem.buildAnnot(attr, rule);
				if (annot) skCtx.addAnnot(annot);
			}
		}
	}

}


SKMETALIB_WSP.registerMetaNode(new SkMPtrItem('PtrItem'));


class SkMPartWsp extends SkMPart {
	tryImportLinks<L>(ctx: OSkImportCtxInternal, linksInfo: L, cache: OSkImportDatas): Promise<ISkImporter[] | null> | null {
		return null;
	}

	_pushLinksImporters<L>(results: ISkImporter[], partRule: SkRuleNode, pos: EPastePos | IImportPos, ctx: OSkImportCtxInternal, linksInfo: L, cache: OSkImportDatas) {
		if (!isShortDescsTransfer(linksInfo)) return;
		//On cherche un attr SkMPtrItem associé
		const ptrItemRule = findPtrItemRule(partRule);
		//On cherche les subModels autorisés en internalisés.
		const subModels = findSubModelRules(partRule);
		const asLink = ptrItemRule && (ctx.preserveUnknown || linksInfo.shortDescs.findIndex((shortDesc: JSrcFields) => shortDesc && sgnMatch(shortDesc, ptrItemRule.itSgnPattern)) >= 0);
		const asSubModel = subModels && subModels.findIndex((v: SkRuleNode) => {
			const model = getModelName(v);
			return linksInfo.shortDescs.findIndex((shortDesc: JSrcFields) => shortDesc && shortDesc.itModel === model) >= 0;
		}) >= 0;
		//if (typeof pos === 'object' && 'replaceChildren' in pos) pos.replaceChildren = null; // le remplacement interne à la part sera géré dans la part.
		if (asLink) results.push(new SkImpTagLink(ctx, linksInfo, partRule, pos, asSubModel));
		if (asSubModel) results.push(new SkImpPartInternalizeLink(ctx, linksInfo, partRule, pos, asLink));
	}

	setInternalizedContent(partNode: SkNode, content: IJmlSet | null, batch: XmlBatch) {
		//On suppr le lien si il existe
		SkMPartWsp.clearLink(partNode, batch);
		//Et remplace ou insert le contenu internalisé
		SkMPartWsp.clearInternalizedContent(partNode, batch);
		if (content) batch.add(new XmlInsertMsg().init(XA.append(XA.fromNode(partNode.node), this.getOffsetAfterMeta(partNode)), content));
	}

	async internalizeLink(partNode: SkNode, shortDesc: JSrcFields, wsp: Wsp, uiContext: HTMLElement, batch: XmlBatch): Promise<XmlBatch> {
		this.setInternalizedContent(partNode, await getContentForInternalize(shortDesc, wsp, uiContext), batch);
		return batch;
	}

	/** Ajoute les remplacements internalisation / externalisation possibles. */
	overwriteAlternates(skAnc: SkNode, parent: SkRuleNode, toReplace: ISkRuleObj, offset: number, nodeType: ENodeType, nodeName: string, res: ISkStructDef[]): ISkStructDef[] {
		if (skAnc.rule !== parent) return res; //on est dans un contexte virtuel, pas internalisation / externalisation possibles.
		const ptrItemRule = findPtrItemRule(parent);
		const subModels = findSubModelRules(parent);
		if (!ptrItemRule || !subModels || subModels.length === 0) return res; //pas d'alternative "userDependant"
		const doc = skAnc.node.ownerDocument as IDocumentInWspHouse;
		if (toReplace === ptrItemRule) {
			//Peut-on internaliser l'item pointé ?
			if (res.length === 1) {
				//Cas particulier : une seule struct internalisée possible, on hack le libellé : pour ne ne pas avoir une répétition avec le label de la part peu compréhensible.
				res[0] = new SwitchInternalizedContent(res[0]);
			}
			const refUri = (skAnc.node as Element).getAttribute(ptrItemRule.matcher.startName);
			if (!refUri) return res;
			const shortDesc = doc.srcRefMap.get(refUri);
			if (!shortDesc || shortDesc instanceof Promise) return res;
			const itemType = doc.wsp.wspMetaUi.getItemTypes().find((it) => it.getSgn() === shortDesc.itSgn);
			if (!itemType || itemType.getFamily() !== EItemTypeFamily.xml) return res;
			const tagRoot = itemType.getTagRoot();
			const targetRule = subModels.find(v => v.matcher.matchNode(ENodeType.element, tagRoot));
			if (!targetRule) return res;
			res.push(new InternalizeItem(skAnc, ptrItemRule, targetRule));
		} else if (doc.wsp.reg.getSvc("wedExternalizeItem")) {
			//Peut-on externaliser le contenu vers un item ?
			const comppo = skAnc.node.lastElementChild;
			if (!comppo) return res;
			const skCompo = skAnc.schemaDom.getSkNode(comppo);
			if (!skCompo || skCompo.rule !== toReplace) return res;
			const itemType = doc.wsp.wspMetaUi.getItemTypes().find((it) => it.getTagRoot() === comppo.nodeName);
			if (!itemType) return res;
			res.push(new ExternalizeItem(skAnc, toReplace, ptrItemRule, itemType));
		}
		return res;
	}

	static clearLink(partNode: SkNode, batch: XmlBatch) {
		const ptrItemRule = findPtrItemRule(partNode.rule);
		if (ptrItemRule && (partNode.node as Element).hasAttribute(ptrItemRule.matcher.startName)) batch.add(new XmlStrMsg().init(XA.append(XA.fromNode(partNode.node), ptrItemRule.matcher.startName), null));
	}

	static clearInternalizedContent(partNode: SkNode, batch: XmlBatch) {
		let ch = partNode.node.lastElementChild;
		while (ch) {
			const chSk = partNode.schemaDom.getSkNode(ch);
			if (chSk && chSk.rule.skMeta instanceof SkMCompo) batch.add(new XmlDeleteMsg().init(XA.fromNode(ch), 1));
			ch = ch.previousElementSibling;
		}
	}

	static setLink(partNode: SkNode, srcRef: srcRef, batch: XmlBatch) {
		//On supprime le contenu internalisé si il existe.
		SkMPartWsp.clearInternalizedContent(partNode, batch);
		//Et on affecte le lien
		batch.add(new XmlStrMsg().init(XA.append(XA.fromNode(partNode.node), (partNode.rule as IPartProps).ptrItem.matcher.startName), srcRef));
	}
}

SKMETALIB_WSP.registerMetaNode(new SkMPartWsp('Part'));

/** Props associées au SkRule donnant le chemin pour créer un contenu de type url. */
export interface ISkMUrlHolder {
	urlHolderRules?: ISkRuleObj[] | null
}

/**
 * SkMeta pour des éléments dont le textContent est une url.
 * note : enrichir SkImpUrl pour gérer aussi une url dans un SkRuleAttr
 */
export class SkMFieldUrl extends SkMField {
	initSkRule(skRule: SkRuleNode & ISkMUrlHolder, confRule: Element) {
		super.initSkRule(skRule, confRule);
		skRule.urlHolderRules = [skRule];
	}

	tryImportLinks<L>(ctx: OSkImportCtxInternal, linksInfo: L, cache: OSkImportDatas): Promise<ISkImporter[] | null> | null {
		return null;
	}

	/**
	 * On gère le lien dans _pushLinksImporters() et pas dans tryImportLinks() pour que l'ihm propose l'insertion
	 * d'un field fils à partir d'un noeud parent et pas seulement si l'elt associé à ce SkMFieldUrl est présent dans
	 * l'éditeur (en réel ou virtuel).
	 */
	_pushLinksImporters<L>(results: ISkImporter[], skRule: ISkRuleObj, pos: EPastePos | IImportPos, ctx: OSkImportCtxInternal, linksInfo: L, cache: OSkImportDatas) {
		if (linksInfo instanceof ShortDescsFromUrlList) {
			results.push(new SkImpUrl(ctx, skRule, linksInfo, pos));
		}
	}
}

SKMETALIB_WSP.registerMetaNode(new SkMFieldUrl('FieldUrl'));

/** SkMeta pour les RemotePrim */
class SkMRemote extends SkMObject {
	/** On se déclare ISkMUrlHolder pour être trouvé comme détenteur d'une url dans par notre container. */
	initSkRule(skRule: SkRuleElt & ISkMUrlHolder, confRule: Element) {
		super.initSkRule(skRule, confRule);
		Object.defineProperty(skRule, "urlHolderRules", {
			//Lazy init : skRule.contentRule pas encore dispo à l'appel de skRule.initSkRule()
			get(this: SkRuleElt & ISkMUrlHolder): any {
				const locationRule: SkRule & ISkMUrlHolder = this.contentRule.findRule((r) => (r as ISkMUrlHolder).urlHolderRules != null);
				const value = locationRule ? [this, ...locationRule.urlHolderRules] : null;
				Object.defineProperty(this, "urlHolderRules", {value});
				return value;
			},
			configurable: true
		});
	}
}

SKMETALIB_WSP.registerMetaNode(new SkMRemote('Remote'));

/**
 * Import d'une url enveloppée dans un élément défini par skRule
 */
class SkImpUrl extends SkImpSimple {

	constructor(ctx: OSkImportCtxInternal, public skRule: ISkRuleObj, public infoLinks: IShortDescsTransfer, pos: EPastePos | IImportPos) {
		super(ctx, "", 0, pos);
	}

	getLabel() {
		return this.skRule.structLabel;
	}

	async completeDatasAtDrop(data: DataTransfer): Promise<void | 'stop'> {
		if (await this.infoLinks.extractDatasNow(data) === 'stop') return 'stop';
		const url = await REMOTE.aliasUrl((this.infoLinks.shortDescs[0] as IShortDescUrlTransfer).url.trim(), (this.schemaDom.document as IDocumentInWspHouse).wsp.reg);
		const elt = (this.skRule as SkRuleElt).createNode(DOM.sharedXmlDoc());
		elt.textContent = url;
		this.contentToImport = [elt];
	}
}

/**
 * Import d'une url enveloppée dans une hiérarchie de skRules
 */
class SkImpDeepUrl extends SkImpBase {

	urls: string[]

	constructor(ctx: OSkImportCtxInternal, public skRules: ISkRuleObj[], public infoLinks: IShortDescsTransfer, pos: EPastePos | IImportPos, public wrapSel: boolean) {
		super(ctx.schemaDom, pos);
		this.malus = 0;
	}

	getLabel() {
		return this.skRules[0].structLabel;
	}

	async completeDatasAtDrop(data: DataTransfer): Promise<void | 'stop'> {
		if (await this.infoLinks.extractDatasNow(data) === 'stop') return 'stop';
		this.urls = this.infoLinks.shortDescs.map((sd: IShortDescUrlTransfer) => sd.url.trim());
	}

	doImport(context: OSkPasteContext, batch: XmlBatch) {
		let ctx = SKMETA.buildSkImportCtxInternal(context, this.schemaDom);
		let jml: IJmlSet = [];
		const multiPaste = this.urls.length > 1 && CARD.isRepeatable(
			(ctxLastSkRule(ctx) as SkRuleNode || ctx.skNode.rule).contentRule.getRealCardSubNode(ENodeType.element, this.skRules[0].matcher.startName)
		);
		const start = context.sel.start;
		const end = context.sel.end;
		let urlDone = 0;
		let sk: SkNode;
		batch.setSelBefore(start, end);
		if (end && ctx.ctn instanceof Element && XA.isInSameSeq(start, end)
			&& XA.last(end) as number - (XA.last(start) as number) === 1
			&& (sk = this.schemaDom.getSkNode(ctx.ctn.childNodes[XA.last(start) as number])).rule === this.skRules[0]) {
			//Cas particulier du remplacement de la 1ere url existante
			for (let offset = 1; offset < this.skRules.length; offset++) {
				const importPos = this.schemaDom.getImportPos(sk.node, this.skRules[offset]);
				if (importPos.replaceChildren) {
					//On s'enfonce dans this.skRules
					sk = this.schemaDom.getSkNode(sk.node.childNodes[importPos.replaceChildren[0] as number]);
				} else {
					//Cette struct n'existe pas (plus?), on la crée.
					const doc = DOM.sharedXmlDoc();
					let firstNode: Node = doc.createTextNode(this.urls[0]);
					for (let depth = this.skRules.length - 1; depth >= offset; depth--) {
						let newCt = (this.skRules[depth] as SkRuleElt).createNode(doc);
						newCt.appendChild(firstNode);
						firstNode = newCt;
					}
					batch.add(new XmlInsertMsg().init(XA.append(XA.fromNode(sk.node), importPos.insertOffsetMax), JML.dom2jml(firstNode)));
					sk = null;
					break;
				}
			}
			if (sk != null) {
				const textNode = DOM.findFirstChild(sk.node, DOM.IS_text);
				if (textNode) {
					batch.add(new XmlStrMsg().init(XA.fromNode(textNode), this.urls[0]));
				} else {
					batch.add(new XmlInsertMsg().init(XA.append(XA.fromNode(sk.node), 0), [this.urls[0]]));
				}
			}
			if (multiPaste) {
				//On change le context pour les liens suivants
				ctx = SKMETA.buildSkImportCtxInternal({
					sel: {start: ctx.sel.end}
				}, ctx.schemaDom);
			} else {
				batch.setSelAfterSeq(start, 1);
				return;
			}
			urlDone++;
		}
		//Préparation du Fragment à cloner
		const doc = DOM.sharedXmlDoc();
		const urlText = doc.createTextNode(this.urls[urlDone]);
		let tag: Node = urlText;
		for (let depth = this.skRules.length - 1; depth >= 0; depth--) {
			let newCt = (this.skRules[depth] as SkRuleElt).createNode(doc);
			newCt.appendChild(tag);
			tag = newCt;
		}
		if (urlDone === 0) {
			//Insertion de la 1ere url
			if (this.wrapSel && !XA.isCollapsed(ctx.sel)) {
				const firstTag = (multiPaste ? tag.cloneNode(true) : tag) as Element;
				ctx.schemaDom.exportRange({start: ctx.sel.start, end: ctx.sel.end}, firstTag);
				new SchemaDom(ctx.schemaDom.schema, this.skRules[0] as SkRuleNode, firstTag).correctDocument({autoMutate: true, autoComplete: true, autoCleanup: true, autoNormXml: true, autoNormChars: true});
				jml = JML.dom2jml(firstTag);
			} else {
				this.addJmlTag(jml, this.urls[urlDone], urlText, tag);
			}
			urlDone++;
		}
		if (multiPaste) while (urlDone < this.urls.length) {
			//Insertion des autres urls
			this.addJmlTag(jml, this.urls[urlDone++], urlText, tag);
		}
		if (jml.length > 0) SKMETA.doPasteReplaceSel(jml, ctx, ctx.schemaDom, batch);
	}

	addJmlTag(jml: IJmlSet, url: string, urlText: Text, tag: Node) {
		urlText.nodeValue = url;
		const txt = this.wrapSel ? tag.appendChild(tag.ownerDocument.createTextNode(url)) : null;
		JML.dom2jml(tag, jml);
		txt?.remove();
	}
}


/** Part SpTe */
class SkMSpTeSegmentWsp extends SkMSpTeSegment {
}

LANG.completeClassProps(SkMPartWsp, SkMSpTeSegmentWsp);

SKMETALIB_WSP.registerMetaNode(new SkMSpTeSegmentWsp('SpTeSegment'));


/**
 *
 */
class SwitchInternalizedContent implements ISkStructDef {
	constructor(public subStructDef: ISkStructDef) {
	}

	get structType(): ENodeType | EFuzzyType | EDirectiveType {return this.subStructDef.structType};

	get structName(): string {return this.subStructDef.structName};

	get structLabel(): string {return "Contenu internalisé vierge"};

	structMatch(nodeType: ENodeType, nodeName?: string): boolean {
		return this.subStructDef.structMatch(nodeType, nodeName);
	}

	createContent(childrenToAppend?: IJmlSet, attsToAppend?: IJmlObj): void | string {
		return this.subStructDef.createContent(childrenToAppend, attsToAppend);
	}
}

class InternalizeItem implements ISkStructDef {

	constructor(public skParent: SkNode, public fromRule: ISkRuleObj, public targetRule: ISkRuleObj) {
	}

	get structType(): ENodeType | EFuzzyType | EDirectiveType {return this.targetRule.structType};

	get structName(): string {return this.targetRule.structName};

	get structLabel(): string {return "Internaliser cet item"};

	async createContentAsync(childrenToAppend: IJmlSet, attsToAppend: IJmlObj, uiContext?: HTMLElement): Promise<void | string | false> {
		const refUri = (this.skParent.node as Element).getAttribute(this.fromRule.matcher.startName);
		childrenToAppend.push(...await getContentItemForInternalize(refUri, (this.skParent.node.ownerDocument as IDocumentInWspHouse).wsp, uiContext));
	}

	createContent(childrenToAppend?: IJmlSet, attsToAppend?: IJmlObj): void | string {
		throw Error("Use createContentAsync()");
	}

	structMatch(nodeType: ENodeType, nodeName?: string): boolean {
		return this.targetRule.structMatch(nodeType, nodeName);
	}
}

class ExternalizeItem extends InternalizeItem {

	constructor(skParent: SkNode, fromRule: ISkRuleObj, targetRule: ISkRuleObj, public itemType: ItemType) {
		super(skParent, fromRule, targetRule);
	}

	get structLabel(): string {return "Externaliser ce contenu..."};

	async createContentAsync(childrenToAppend: IJmlSet, attsToAppend: IJmlObj, uiCtx?: HTMLElement): Promise<void | string | false> {
		const wsp = (this.skParent.node.ownerDocument as IDocumentInWspHouse).wsp;
		const content = this.skParent.node.lastElementChild;
		if (!content) return false;
		const svc = wsp.reg.getSvc<(from: IReg<IWspEnv>, content: Element, itTypesReducer: (acc: ItemType[], cur: ItemType, idx?: number, src?: ItemType[]) => ItemType[], uiCtx?: HTMLElement) => Promise<JSrcFields>>("wedExternalizeItem");
		const shortDesc = await svc(wsp.reg, content, (acc: ItemType[], cur: ItemType) => {
			if (cur === this.itemType) acc.push(cur);
			return acc;
		}, uiCtx);
		if (shortDesc) {
			attsToAppend[this.targetRule.matcher.startName] = SRC.srcRef(shortDesc);
			return;
		}
		return false;
	}
}


//
// const paraLinksImporterBd = {
// 	_pushLinksImporters<L>(results: ISkImporter[], skRule: ISkRuleReal, pos: EPastePos, ctx: OSkPasteCtxInternal, linksInfo: L, cache: OSkImportCache): void {
// 		if (!isShortDescsTransfer(linksInfo)) return;
//
// 	}
// } as ILinksImporterBuilder;
//

async function tryPasteLinksInPara(this: ISkMetaNode, ctx: OSkImportCtxInternal, linksInfo: IShortDescsTransfer, cache: OSkImportDatas): Promise<ISkImporter[]> {
	if (!isShortDescsTransfer(linksInfo)) return;
	//Recherche des tags inlines susceptibles d'accepter ce lien.
	const lastRule = SKMETA.ctxLastSkRule(ctx) as SkRuleNode;
	const inlineRules = lastRule.contentRule.findRules((rule: SkRule) => {
		if (rule.skMeta && rule instanceof SkRuleNode) {
			const ptrRule = findPtrItemRule(rule);
			return ptrRule && (ctx.preserveUnknown || linksInfo.shortDescs.find((s) => sgnMatchRule(s, ptrRule)) != null);
		}
		return false;
	}, []) as SkRuleNode[];
	//Recherche des tags "paraSibling" susceptibles d'accepter ce lien.
	let paraParentSk: SkNode;
	//on remonte du noeud texte si virtualPath pointe un texte.
	let deltaDepth = ctx.virtualPath && ctx.virtualPath[ctx.virtualPath.length - 1] === "#" ? 1 : 0;
	//puis on remonte jusqu'au 1er paraParent.
	const paraParentRule = SKMETA.ctxFindSkRuleInAnc(ctx, (r: SkRule, n?: SkNode) => {
		if ((r.skMeta as ISkMInText).isParaParent) {
			paraParentSk = n;
			return true;
		}
		deltaDepth++;
		return false;
	}) as SkRuleNode;
	const paraRules = paraParentRule ? paraParentRule.contentRule.findRules((rule: SkRule) => {
		if (rule.skMeta && rule instanceof SkRuleNode) {
			const ptrRule = findPtrItemRule(rule);
			return ptrRule && (ctx.preserveUnknown || linksInfo.shortDescs.find((s) => sgnMatchRule(s, ptrRule)) != null);
		}
		return false;
	}, []) as SkRuleNode[] : [];
	if (inlineRules.length === 0 && paraRules.length === 0) return []; //aucun lien acceptable

	const imports = inlineRules.map((r) => new SkImpTxtLink(ctx, linksInfo, r, EPastePos.replace, r.skMeta.id === "InlLink")) as ISkImporter[];
	if (paraRules.length > 0) {
		let paraImports: ISkImporter[];
		if (paraParentSk) {
			//Le paraParent n'est pas virtuel,
			paraImports = paraRules.map((r) => new SkImpTxtLink(ctx, linksInfo, r, EPastePos.replace));
			SkMPara.wrapImportForParaSiblings(paraImports, paraParentSk.node, ctx);
		} else {
			paraImports = paraRules.map((r) => new SkImpGoUp(ctx.schemaDom, new SkImpTxtLink(ctx, linksInfo, r, EPastePos.replace), deltaDepth, 'before'));
		}
		imports.push(...paraImports);
	}
	return imports;
}


async function tryPasteLinksInParaParent(this: ISkMetaNode, ctx: OSkImportCtxInternal, linksInfo: IShortDescsTransfer, cache: OSkImportDatas): Promise<ISkImporter[]> {
	const paraRules = ctx.skNode.rule.contentRule.findRules((rule: SkRule) => {
		return rule.skMeta && rule instanceof SkRuleNode && isRuleMatchLinks(ctx, findPtrItemRule(rule), linksInfo);
	}, []) as SkRuleNode[];
	return paraRules.map((r) => new SkImpTxtLink(ctx, linksInfo, r, EPastePos.replace));
}

function _pushLinksImporters<L>(this: ISkMetaNode, results: ISkImporter[], tagRule: SkRuleNode, pos: EPastePos | IImportPos, ctx: OSkImportCtxInternal, linksInfo: L, cache: OSkImportDatas) {
	if (!isShortDescsTransfer(linksInfo)) return;
	if (isRuleMatchLinks(ctx, findPtrItemRule(tagRule), linksInfo)) {
		results.push(new SkImpTxtLink(ctx, linksInfo, tagRule, pos, this.id === "InlLink"));
	}
}

function _pushLinksImportersInMetas<L>(this: ISkMetaNode, results: ISkImporter[], tagRule: SkRuleNode & ISkMUrlHolder, pos: EPastePos | IImportPos, ctx: OSkImportCtxInternal, linksInfo: L, cache: OSkImportDatas) {
	if (!isShortDescsTransfer(linksInfo) || !linksInfo.isImportUrls) return;
	if (tagRule.urlHolderRules === undefined) {
		//Recherche d'un élélment de type url dans les metas de cette struct
		tagRule.urlHolderRules = null;
		if (tagRule.skMeta instanceof SkMObject) {
			const metaRule = tagRule.skMeta.getMetaRule(tagRule);
			if (metaRule) for (let fieldRule of metaRule.contentRule.findRules((r) => r.skMeta instanceof SkMField)) {
				if ((fieldRule as ISkMUrlHolder).urlHolderRules != null) {
					//Field de type url.
					tagRule.urlHolderRules = [tagRule, metaRule, ...(fieldRule as ISkMUrlHolder).urlHolderRules];
					break;
				} else {
					const urlHolderRules = ((fieldRule as SkRuleElt)?.contentRule.findRule((r) => (r as ISkMUrlHolder).urlHolderRules != null) as ISkMUrlHolder)?.urlHolderRules;
					if (urlHolderRules) {
						//Field contenant un modèle ISkMUrlHolder (Remote).
						tagRule.urlHolderRules = [tagRule, metaRule, fieldRule, ...urlHolderRules];
						break;
					}
				}
			}
		}
	}
	if (tagRule.urlHolderRules) {
		//console.log("_pushLinksImportersInMetas:::", pos, tagRule);
		results.push(new SkImpDeepUrl(ctx, tagRule.urlHolderRules, linksInfo, pos, this.id === "InlPhrase" || this.id === "InlTextLeaf"));
	}
}

function isRuleMatchLinks(ctx: OSkImportCtxInternal, ptrRule: IPtrItemRule | null, linksInfo: IShortDescsTransfer) {
	if (ctx.preserveUnknown) return true;
	if (!ptrRule) return false;
	if (linksInfo.rejectSgnMatch) {
		return !linksInfo.rejectSgnMatch(ptrRule.itSgnPattern);
	} else {
		return linksInfo.shortDescs.find((s: JSrcFields) => sgnMatchRule(s, ptrRule)) != null;
	}
}

function overrideLinks(id: string,
											 tryPasteLinks: (ctx: OSkImportCtxInternal, linksInfo: any, cache: OSkImportDatas) => Promise<ISkImporter[]>,
											 _pushLinksImporters?: (results: ISkImporter[], partRule: SkRuleNode, pos: EPastePos | IImportPos, ctx: OSkImportCtxInternal, linksInfo: any, cache: OSkImportDatas) => void
): ISkMetaNode {
	const skm = SKMETALIB.getMetaNode(id);
	const skmWsp = new (skm.constructor as any)(id) as ISkMetaNode;
	if (tryPasteLinks) skmWsp.tryPasteLinks = tryPasteLinks;
	if (_pushLinksImporters) {
		skmWsp.tryImportLinks = function () {return null}
		skmWsp._pushLinksImporters = _pushLinksImporters;
	}
	return skmWsp;
}

SKMETALIB_WSP.registerMetaNode(overrideLinks('Para', tryPasteLinksInPara));
SKMETALIB_WSP.registerMetaNode(overrideLinks('InlPhrase', tryPasteLinksInPara, _pushLinksImportersInMetas));
SKMETALIB_WSP.registerMetaNode(overrideLinks('InlLink', tryPasteLinksInPara, _pushLinksImporters));
SKMETALIB_WSP.registerMetaNode(overrideLinks('InlStyle', tryPasteLinksInPara));
SKMETALIB_WSP.registerMetaNode(overrideLinks('InlTextLeaf', tryPasteLinksInPara, _pushLinksImportersInMetas));
SKMETALIB_WSP.registerMetaNode(overrideLinks('InlObject', null, _pushLinksImporters));
SKMETALIB_WSP.registerMetaNode(overrideLinks('InlImg', null, _pushLinksImporters));
SKMETALIB_WSP.registerMetaNode(overrideLinks('InlEmpty', null, _pushLinksImportersInMetas));

SKMETALIB_WSP.registerMetaNode(overrideLinks('Text', tryPasteLinksInParaParent));
SKMETALIB_WSP.registerMetaNode(overrideLinks('LI', tryPasteLinksInParaParent));
SKMETALIB_WSP.registerMetaNode(overrideLinks('TxtCell', tryPasteLinksInParaParent));
SKMETALIB_WSP.registerMetaNode(overrideLinks('TxtObject', null, _pushLinksImporters));
SKMETALIB_WSP.registerMetaNode(overrideLinks('TxtEmpty', null, _pushLinksImportersInMetas));


export interface IDocumentInWspHouse extends Document {
	wsp: Wsp
	/** Map des items liés (shortDesc + subItems). */
	srcRefMap: Map<srcRef, JSrcFields | null /* item absent (inexistant, supprimé...) */ | Promise<JSrcFields>>
}

class SkAnnotFutureLink extends SkAnnotStr {
	static TYPE = "wspLinkFuture";

	anchorNode: Attr;
	srcRefSub: srcRefSub;

	future: Promise<ISkAnnot> | null;
	result?: ISkAnnot | null;

	get type(): string {return SkAnnotFutureLink.TYPE}

	get level(): EAnnotLevel {return this.result ? this.result.level : EAnnotLevel.info}

	init(attr: Attr, rule: IPtrItemRule, pending?: Promise<JSrcFields>): this {
		this.anchorNode = attr;
		const wsp = (attr.ownerDocument as IDocumentInWspHouse).wsp;
		this.srcRefSub = attr.nodeValue;
		const srcRef = ITEM.extractSrcRef(this.srcRefSub);
		if (pending) {
			this.future = pending.then((shortDesc: JSrcFields) => {
				this.future = null;
				this.result = SkMPtrItem.buildAnnot(attr, rule);
				return this.result;
			});
		} else {
			const fetch = wsp.fetchShortDescSubItems(srcRef);
			(attr.ownerDocument as IDocumentInWspHouse).srcRefMap.set(srcRef, fetch);
			this.future = fetch.then((shortDesc: JSrcFields) => {
				(attr.ownerDocument as IDocumentInWspHouse).srcRefMap.set(srcRef, shortDesc.srcSt > 0 ? shortDesc : null);
				this.future = null;
				this.result = SkMPtrItem.buildAnnot(attr, rule);
				return this.result;
			});
		}
		return this;
	}

	getLabel(): string {return this.result ? this.result.getLabel() : this.result === undefined ? "Validation du lien en cours..." : ""}

	equals(other: ISkAnnot): boolean {return this.anchorNode === other.anchorNode && this.type === other.type && this.srcRefSub === (other as SkAnnotFutureLink).srcRefSub}

	toJSON(): any {
		return this.result ? this.result.toJSON() : {type: this.type, anchor: this.start}
	}
}

interface IModelProps {
	modelName?: string
}

/** Le name d'un Model SC est le QName de sa balise racine avec le ':' remplacé par un '_'. */
function getModelName(compoRule: SkRuleNode): string {
	if ('modelName' in compoRule) return (compoRule as IModelProps).modelName;
	return (compoRule as IModelProps).modelName = compoRule.matcher.startName.replace(":", "_");
}


/** part d'une compo, objectLeaf, img... du texte : ref vers la rule sc:refUri. */
interface ILinkerProps {
	/** @see findPtrItemRule() pour l'obtenir. */
	ptrItem?: IPtrItemRule
}

interface IPartProps extends ILinkerProps {
	/** @see findSubModelRules() pour l'obtenir. */
	subModels?: SkRuleNode[]
}

function findPtrItemRule(linkerRule: SkRuleNode): IPtrItemRule {
	if ('ptrItem' in linkerRule) return (linkerRule as ILinkerProps).ptrItem;
	return (linkerRule as ILinkerProps).ptrItem = linkerRule.contentRule.findRule((r: SkRule) => r.skMeta instanceof SkMPtrItem) as IPtrItemRule;
}

function findSubModelRules(partRule: SkRuleNode): SkRuleNode[] {
	if ('subModels' in partRule) return (partRule as IPartProps).subModels;
	return (partRule as IPartProps).subModels = partRule.contentRule.findRules((r: SkRule) => r.skMeta && r.skMeta instanceof SkMCompo) as SkRuleNode[];
}

export interface IPtrItemRule extends SkRuleAttr {
	skMeta: SkMPtrItem
	itSgnPattern?: RegExp
	subItSgnPattern?: RegExp
}

/**
 * Pattern pour
 * - matcher un espace : $^
 * - matcher tout item, sauf espace : .+
 * - matcher tout item ou espace : null ou .*
 */
function sgnMatch(shortDesc: JSrcFields, pattern: RegExp | null): boolean {
	if (pattern == null) return true;
	return pattern.test(shortDesc.itSgn || "");
}

function subSgnMatch(subItem: JSubItem | JSrcFields, pattern: RegExp | null): boolean {
	const mo = (subItem as JSubItem).mo || (subItem as JSrcFields).itSgn;
	if (pattern == null || mo == null) return true;
	return pattern.test(mo);
}

/* match strict pour le subItSgnPattern : contrôle du pattern ET de la présence */
function sgnMatchRule(shortDesc: JSrcFields, rule: IPtrItemRule) {
	if (!sgnMatch(shortDesc, rule.itSgnPattern)) return false;
	if (rule.subItSgnPattern) {
		return subSgnMatch(shortDesc.itSubItem || shortDesc, rule.subItSgnPattern);
	} else
		return shortDesc.itSubItem ? false : true;
}

function getOwnerEltCard(ctx: OSkImportCtxInternal): ECard {
	if (ctx.skRuleStack.length === 1) {
		//L'elt owner de l'attribut existe.
		const ownerElt = ctx.ctn instanceof Attr ? ctx.ctn.ownerElement : ctx.ctn;
		return ctx.schemaDom.getSkNode(ownerElt.parentElement).rule.contentRule.getRealCardSubNode(ENodeType.element, ownerElt.nodeName);
	} else if (ctx.skRuleStack.length === 2) {
		//L'elt owner de l'attribut est virtuel, mais pas son contexte parent.
		const ownerRule = ctx.skRuleStack[0] as SkRuleElt;
		if (ownerRule.matcher.isFuzzy()) return ownerRule.card; //Rule avec matcher fuzzy, manque un algo pour être exact, mais ne devrait jamais arriver dans no usages.
		const parentElt = ctx.ctn;
		return ctx.schemaDom.getSkNode(parentElt).rule.contentRule.getRealCardSubNode(ENodeType.element, ownerRule.matcher.startName);
	} else {
		//L'elt owner de l'attribut et son context parent sont virtuels.
		const ownerRule = ctx.skRuleStack[ctx.skRuleStack.length - 2] as SkRuleElt;
		if (ownerRule.matcher.isFuzzy()) return ownerRule.card; //Rule avec matcher fuzzy, manque un algo pour être exact, mais ne devrait jamais arriver dans no usages.
		const parentRule = ctx.skRuleStack[ctx.skRuleStack.length - 3] as SkRuleElt;
		return parentRule.contentRule.getRealCardSubNode(ENodeType.element, ownerRule.matcher.startName);
	}
}

async function getContentForInternalize(shortDesc: IShortDescTransfer, wsp: Wsp, uiContext: HTMLElement): Promise<IJmlSet | null> {
	if (shortDesc.createSrc) return null;
	// if (shortDesc.createSrc) {
	// 	shortDesc = await shortDesc.createSrc({targetSrcType: "item"});
	// 	if (!shortDesc) return null;
	// }
	return getContentItemForInternalize(SRC.srcRef(shortDesc), wsp, uiContext);
}

async function getContentItemForInternalize(srcRef: srcRef, wsp: Wsp, uiContext: HTMLElement): Promise<IJmlSet | null> {
	const house = wsp.wspServer.wspsLive.getHouseIfFetched(WSP.buildWspRef(wsp.code, srcRef));
	const dom = house ? house.document : await ITEM.fetchDom(wsp, uiContext, srcRef);
	return JML.dom2jml(dom.documentElement.lastElementChild);
}


/** skMetaModel qui peuvent contenir un lien (PtrIem). */
const SKMETA_PTRITEM = ["Part", "Field", "InlObject", "InlImg", "InlLink", "TxtObject", "*" /* elts inconnus + SCbuilder */];

/** Revalidation des liens suite à un changement de itSgn d'un srcRef. */
export function revalidLink(house: IWspXmlHouse, srcRef: srcRef, newShortDesc: JSrcFields) {
	if (!(house.schemaDom.schema as any).wspPtrItemsMarked) {
		//Marquage des SkRuleNode de ce schema pour repérer les ptrItems.
		(house.schemaDom.schema as any).wspPtrItemsMarked = true;
		const done = new Set<SkRule>();

		function scanRule(r: SkRule) {
			if (!r || done.has(r)) return false;
			done.add(r);
			if (r.skMeta && SKMETA_PTRITEM.indexOf(r.skMeta.id) >= 0) findPtrItemRule(r as SkRuleNode);
			if ('contentRule' in r) scanRule((r as SkRuleNode).contentRule.findRule(scanRule));
			return false;
		}

		scanRule(house.schemaDom.schema.startRule.findRule(scanRule));
	}
	(house.document as IDocumentInWspHouse).srcRefMap.set(srcRef, newShortDesc);
	const schema = house.schemaDom;
	const tw = house.document.createTreeWalker(house.document, NodeFilter.SHOW_ELEMENT);
	let elt: Element;
	let revalid: Set<Element>;
	while ((elt = tw.nextNode() as Element)) {
		const rule = schema.getSkNode(elt).rule as SkRule & ILinkerProps;
		if (rule.ptrItem) {
			const lnkSrcRef = elt.getAttribute(rule.ptrItem.matcher.startName) as srcRefSub;
			if (ITEM.isSameSrcRef(srcRef, lnkSrcRef)) {
				if (!revalid) revalid = new Set();
				revalid.add(elt);
			}
		}
	}
	if (revalid) {
		house.revalid(revalid);
	} else {
		//plus utilisé, cleanup.
		(house.document as IDocumentInWspHouse).srcRefMap.delete(srcRef);
	}
}

/**
 * Affectation de l'attribut du lien avec gestion éventuelle de la duplication de la balise
 * si collage de N liens.
 */
class SkImpSrcUri extends SkImpSimple {

	isRepeatable: boolean;
	nextLinks: JSrcFields[];

	constructor(public ctx: OSkImportCtxInternal, public ptrItemRule: IPtrItemRule, public infoLinks: IShortDescsTransfer, public firstLink: number) {
		super(ctx, infoLinks.isImport ? "" : ITEM.srcRefSub(infoLinks.shortDescs[firstLink]));
		this.isRepeatable = CARD.isRepeatable(getOwnerEltCard(ctx));
	}

	async completeDatasAtDrop(data: DataTransfer) {
		if (this.infoLinks.extractDatasNow) return this.infoLinks.extractDatasNow(data);
	}

	/** Async si au moins un item doit être créé. */
	get needAsyncBuild(): boolean {return this.infoLinks.isImport}

	/**
	 * Création de tous les items nécessaires.
	 */
	async buildContentToImport?(uiCtx?: HTMLElement): Promise<void | "stop"> {
		const sgnPattern = this.ptrItemRule.itSgnPattern;
		const subItSgnPattern = this.ptrItemRule.subItSgnPattern;
		const repeatable = this.isRepeatable && this.infoLinks.shortDescs.length > this.firstLink + 1;
		const createOpts = {
			targetSrcType: "item",
			sgnPattern, subItSgnPattern,
			defaultUriParent: SRC.extractUriParent((this.ctx.schemaDom.house as IWspXmlHouse).srcFields.srcUri),
			refExtItemAcceptable: true,
			repeatedImports: repeatable ? {} : undefined
		} as OImportInterWspOptions;
		let lnk = this.infoLinks.shortDescs[this.firstLink];
		if (lnk.createSrc) {
			lnk = await lnk.createSrc(createOpts);
			if (!lnk) return 'stop'; //Si 1er lien abandonné, on stop.
		}
		this.contentToImport = ITEM.srcRefSub(lnk);
		if (repeatable) {
			this.nextLinks = [];
			const nexts = this.infoLinks.shortDescs;
			for (let i = this.firstLink + 1; i < nexts.length; i++) {
				let lnk = nexts[i];
				if (!lnk || !(this.ctx.preserveUnknown || (sgnMatch(lnk, sgnPattern) && subSgnMatch(lnk.itSubItem || lnk, subItSgnPattern)))) continue;
				if (lnk.createSrc) lnk = await lnk.createSrc(createOpts);
				if (lnk) this.nextLinks.push(lnk);
			}
		}
	}

	doImport(context: OSkPasteContext, batch: XmlBatch): void {
		//On import le 1er lien.
		super.doImport(context, batch);
		if (this.isRepeatable) {
			//Le ownerElement est bien en card N, on peut le dupliquer.
			if (!this.nextLinks) {
				//Liens suivants pas encore définis.
				this.nextLinks = [];
				const nexts = this.infoLinks.shortDescs;
				for (let i = this.firstLink + 1; i < nexts.length; i++) {
					const lnk = nexts[i];
					if (!lnk || !(this.ctx.preserveUnknown || (sgnMatch(lnk, this.ptrItemRule.itSgnPattern) && subSgnMatch(lnk.itSubItem || lnk, this.ptrItemRule.subItSgnPattern)))) continue;
					if (lnk) this.nextLinks.push(lnk);
				}
			}
			//On cree le JML à insérer.
			const ctx = context as OSkImportCtxInternal;
			const jmlLinks: IJmlSet = [];
			const attName = (SKMETA.ctxLastSkRule(ctx) as SkRuleAttr).matcher.startName;
			for (const scrField of this.nextLinks) {
				const linkIdx = jmlLinks.length;
				if (ctx.skRuleStack.length === 1) {
					JML.domNode2jml(ctx.ctn instanceof Attr ? ctx.ctn.ownerElement : ctx.ctn, jmlLinks);
				} else {
					ctx.skRuleStack[ctx.skRuleStack.length - 2].createContent(jmlLinks);
				}
				(jmlLinks[linkIdx] as IJmlObj)[attName] = ITEM.srcRefSub(scrField);
			}
			batch.add(new XmlInsertMsg().init(XA.newBd(ctx.sel.start).up().incrAtDepth(-1, 1).xa, jmlLinks));
			batch.setSelAfterSeq(XA.newBd(ctx.sel.start).up().xa, JML.lengthJmlOrText(jmlLinks) + 1);
		}
	}
}

/**
 * Import d'une balise avec un lien (Part, Field, balise texte avec lien...).
 */
class SkImpTagLink extends SkImpBase {

	protected preserveUnknown: boolean;
	protected partRule: SkRuleNode;

	/**
	 * @param linkerRule SkRule de la part.
	 */
	constructor(public ctx: OSkImportCtxInternal, public linksInfos: IShortDescsTransfer, public linkerRule: SkRuleNode & IPartProps, pos: EPastePos | IImportPos, public appendLabel: boolean) {
		super(ctx.schemaDom, pos);
		this.preserveUnknown = ctx.preserveUnknown;
		this.partRule = ctx.skNode.rule;
		this.malus = 0;
	}

	getLabel() {
		return this.appendLabel ? this.linkerRule.structLabel + " (Lien)" : this.linkerRule.structLabel;
	}

	async completeDatasAtDrop(data: DataTransfer): Promise<void | 'stop'> {
		if (this.linksInfos.extractDatasNow) {
			if (await this.linksInfos.extractDatasNow(data) === 'stop') return 'stop';
			if (!this.preserveUnknown) {
				const sgnPattern = this.linkerRule.ptrItem.itSgnPattern;
				//console.log("completeDatasAtDrop  sgnPattern:::", sgnPattern, "  shortDescs::", this.linksInfos.shortDescs);
				if (sgnPattern && this.linksInfos.rejectSgnMatch && this.linksInfos.rejectSgnMatch(sgnPattern)) return 'stop';
			}
		}
	}

	/** Async si au moins un item doit être créé. */
	get needAsyncBuild(): boolean {
		return this.linksInfos.isImport;
	}

	/**
	 * Création de tous les items nécessaires.
	 */
	async buildContentToImport?(uiContext?: HTMLElement): Promise<void | 'stop'> {
		const sgnPattern = this.linkerRule.ptrItem.itSgnPattern;
		const subItSgnPattern = this.linkerRule.ptrItem.subItSgnPattern;
		const filter = (s: JSrcFields) => s && (this.preserveUnknown || s.itSgn == null || (sgnMatch(s, sgnPattern) && subSgnMatch(s.itSubItem || s, subItSgnPattern)));
		const links = this.linksInfos.shortDescs.filter(filter);
		const defaultUriParent = ITEM.extractSpaceUri((this.ctx.schemaDom.house as WspXmlHouse).srcFields?.srcUri);
		const createOpts = {targetSrcType: "item", defaultUriParent, sgnPattern, subItSgnPattern, refExtItemAcceptable: true, repeatedImports: links.length > 1 ? {} : undefined} as OImportInterWspOptions;
		for (let i = 0; i < links.length; i++) {
			const lnk = links[i];
			if (lnk.createSrc) links[i] = await lnk.createSrc(createOpts);
		}
		this._links = links.filter(filter); //On refiltre après createSrc() : itSgn pouvait être inconnu avant.
		if (this._links.length === 0) return 'stop';
	}

	protected _links: JSrcFields[];

	doImport(context: OSkPasteContext, batch: XmlBatch, options?: any): void {
		let ctx = SKMETA.buildSkImportCtxInternal(context, this.schemaDom);
		if (!this._links) {
			//Liste des liens pas encore établie.
			const sgnPattern = this.linkerRule.ptrItem.itSgnPattern;
			this._links = this.linksInfos.shortDescs.filter((s: JSrcFields) => s && (context.preserveUnknown || sgnMatch(s, sgnPattern)));
		}
		if (this._links.length === 0) return;
		const multiPaste = this._links.length > 1 && CARD.isRepeatable(ctx.skNode.rule.contentRule.getRealCardSubNode(ENodeType.element, this.linkerRule.matcher.startName));
		const jml: IJmlSet = [];
		const start = context.sel.start;
		const end = context.sel.end;
		let partSkNode: SkNode;
		if (end && ctx.ctn instanceof Element && XA.isInSameSeq(start, end)
			&& XA.last(end) as number - (XA.last(start) as number) === 1
			&& (partSkNode = this.schemaDom.getSkNode(ctx.ctn.childNodes[XA.last(start) as number])).rule === this.linkerRule) {
			//Cas particulier on remplace le lien dans une seule part (avec gestion de la suppr de l'internalisation)
			SkMPartWsp.setLink(partSkNode, SRC.srcRef(this._links[0]), batch);
			batch.setSelBefore(start); //pour ne pas sel le link dans la part au undo.
			if (multiPaste) {
				//On change le context pour les liens suivants
				ctx = SKMETA.buildSkImportCtxInternal({
					sel: {start: ctx.sel.end}
				}, ctx.schemaDom);
			}
		} else {
			//On ajoute le 1er lien
			this.addJmlTag(this._links[0], jml);
		}
		if (multiPaste) {
			//On insère les liens suivants si la part est en card N.
			for (let i = 1; i < this._links.length; i++) this.addJmlTag(this._links[i], jml);
		}
		if (jml.length > 0) SKMETA.doPasteReplaceSel(jml, ctx, ctx.schemaDom, batch);
	}

	addJmlTag(shortDesc: JSrcFields, jml: IJmlSet, body?: string) {
		const i = jml.length;
		this.linkerRule.createContent(jml);
		(jml[i] as IJmlObj)[this.linkerRule.ptrItem.matcher.startName] = ITEM.srcRefSub(shortDesc);
		if (body) {
			if (!jml[i + 1]) jml.push([body]);
			else (jml[i + 1] as IJmlSet).push(body);
		}
	}

	cleanupContentToPaste(ctx: OSkImportCtxInternal, rootRule: SkRuleNode, rootNode: Document | Element) {
		new SchemaDom(ctx.schemaDom.schema, rootRule, rootNode).correctDocument({autoMutate: true, autoComplete: true, autoCleanup: true, autoNormXml: true, autoNormChars: true});
	}
}

/**
 * Import par internalisation d'un lien sur une Part.
 */
class SkImpPartInternalizeLink extends SkImpTagLink {

	getLabel() {
		return this.appendLabel ? this.linkerRule.structLabel + " (Internaliser le contenu)" : this.linkerRule.structLabel;
	}

	get needAsyncBuild(): boolean {return true}

	/** Chargement de tous les contenus distants. */
	async buildContentToImport?(uiContext?: HTMLElement): Promise<void | "stop"> {
		const subModels = findSubModelRules(this.linkerRule);
		let links = this.linksInfos.shortDescs.filter((s: JSrcFields) => s && (this.preserveUnknown || subModels.findIndex((m: SkRuleNode) => s.itModel === getModelName(m)) >= 0));
		if (links.length > 1) {
			if (!CARD.isRepeatable(this.partRule.contentRule.getRealCardSubNode(ENodeType.element, this.linkerRule.matcher.startName))) {
				//On n'est pas en Card N, on ne peut accepter que le 1er lien.
				links = [links[0]];
			}
		}
		if (links.length > 1) {
			const pending = links.map((lnk: JSrcFields) => getContentForInternalize(lnk, this.linksInfos.wsp, uiContext));
			const jmls = await Promise.all(pending);
			let i = 0;
			while (i < jmls.length) {
				const jml = jmls[i++];
				if (jml) {
					this.firstContent = jml;
					break;
				}
			}
			if (i < jmls.length) {
				this.nextContents = [];
				do {
					const jml = jmls[i++];
					if (jml) this.nextContents.push(jml);
				} while (i < jmls.length)
			}
		} else {
			this.firstContent = await getContentForInternalize(links[0], this.linksInfos.wsp, uiContext);
		}
		return this.firstContent == null ? 'stop' : undefined;
	}

	protected firstContent: IJmlSet;
	protected nextContents: IJmlSet[];

	doImport(context: OSkPasteContext, batch: XmlBatch, options?: any): void {
		//console.log("SkImpPartInternalizeLink:::::", context);
		let ctx = SKMETA.buildSkImportCtxInternal(context, this.schemaDom);
		const jml: IJmlSet = [];
		const start = context.sel.start;
		const end = context.sel.end;
		let partSkNode: SkNode;
		if (end && ctx.ctn instanceof Element && XA.isInSameSeq(start, end)
			&& XA.last(end) as number - (XA.last(start) as number) === 1
			&& (partSkNode = this.schemaDom.getSkNode(ctx.ctn.childNodes[XA.last(start) as number])).rule === this.linkerRule) {
			//Cas particulier on remplace le lien dans une seule part (avec gestion de la suppr de l'internalisation)
			(this.linkerRule.skMeta as SkMPartWsp).setInternalizedContent(partSkNode, this.firstContent, batch);
			batch.setSelBefore(start); //pour ne pas sel le content dans la part au undo.
			if (this.nextContents) {
				//On change le context pour les liens suivants
				ctx = SKMETA.buildSkImportCtxInternal({
					sel: {start: ctx.sel.end}
				}, ctx.schemaDom);
				for (const c of this.nextContents) this.addJmlPartContent(c, jml);
			}
		} else {
			//On insère toutes les parts
			this.addJmlPartContent(this.firstContent, jml);
			if (this.nextContents) for (const c of this.nextContents) this.addJmlPartContent(c, jml);
		}
		if (jml.length > 0) SKMETA.doPasteReplaceSel(jml, ctx, ctx.schemaDom, batch);
	}

	addJmlPartContent(content: IJmlSet, jml: IJmlSet) {
		const i = jml.length + 1;
		this.linkerRule.createContent(jml);
		const children = jml[i] as IJmlSet; //Fils de la part créée
		if (!children) {
			//aucun fils, pas de meta ni de content obligatoire dans la part
			jml.push(content);
		} else {
			//on remplace le sous-modèle issu de 'createContent()' par 'content' ou on l'ajoute si pas trouvé.
			const subModels = findSubModelRules(this.linkerRule);
			const it = new JmlSubSetIterator(children);
			while (it.next()) {
				if (JML.isElt(it.currentNode)) for (let subModel of subModels) {
					if (subModel.matcher.matchNode(JML.jmlNode2nodeType(it.currentNode), JML.jmlNode2name(it.currentNode))) {
						JML.replaceChildren(JML.getJmlChildrenOrBody(content, 0) as IJmlSubSet, it.currentNode, children);
						return;
					}
				}
			}
			//Pas de subModel ajouté par 'createContent()', on ajoute 'content' après les metas.
			children.push(...content);
		}
	}
}


/**
 * Internalise un item. La sel courante pointe l'elt à remplacer (elt d'une Compo par ex).
 * TODO Clone le container si N liens et card multi comme SkImpSrcUri ?
 */
class SkImpInternalize extends SkImpSimple {

	jml: IJmlSet;

	constructor(ctx: OSkImportCtxInternal, public linksInfos: IShortDescsTransfer, public shortDescOffset: number, pos: EPastePos | IImportPos) {
		super(ctx, null, 0, pos);
	}

	get needAsyncBuild(): boolean {return true}

	async buildContentToImport?(uiContext?: HTMLElement): Promise<void | 'stop'> {
		this.jml = await getContentForInternalize(this.linksInfos.shortDescs[this.shortDescOffset], this.linksInfos.wsp, uiContext);
		if (this.jml == null) return 'stop';
	}

	getJml() {
		return this.jml;
	}

}

/**
 * Import d'un lien dans un texte.
 */
class SkImpTxtLink extends SkImpTagLink {

	constructor(oriCtx: OSkImportCtxInternal, linksInfos: IShortDescsTransfer, linkerRule: SkRuleNode & ILinkerProps, pos: EPastePos | IImportPos, public wrapSel?: boolean) {
		super(oriCtx, linksInfos, linkerRule, pos, false);
	}

	doImport(context: OSkPasteContext, batch: XmlBatch, options?: any): void {
		let ctx = SKMETA.buildSkImportCtxInternal(context, this.schemaDom);
		if (!this._links) {
			//Liste des liens pas encore établie.
			const ptrItemRule = this.linkerRule.ptrItem;
			this._links = this.linksInfos.shortDescs.filter((s: JSrcFields) => s && (context.preserveUnknown || sgnMatchRule(s, ptrItemRule)));
		}
		const multiPaste = this._links.length > 1 && CARD.isRepeatable(ctx.skNode.rule.contentRule.getRealCardSubNode(ENodeType.element, this.linkerRule.matcher.startName));
		let jml: IJmlSet = [];
		const start = context.sel.start;
		const end = context.sel.end;
		let linkerSk: SkNode;
		if (end && ctx.ctn instanceof Element && XA.isInSameSeq(start, end)
			&& XA.last(end) as number - (XA.last(start) as number) === 1
			&& (linkerSk = this.schemaDom.getSkNode(ctx.ctn.childNodes[XA.last(start) as number])).rule === this.linkerRule) {
			//Cas particulier on remplace le lien actuel pointé par la sélection
			batch.add(new XmlStrMsg().init(XA.append(XA.fromNode(linkerSk.node), (linkerSk.rule as IPartProps).ptrItem.matcher.startName), SRC.srcRef(this._links[0])));
			batch.setSelBeforeSeq(start, 1);
			if (multiPaste) {
				//On change le context pour les liens suivants
				ctx = SKMETA.buildSkImportCtxInternal({
					sel: {start: ctx.sel.end}
				}, ctx.schemaDom);
			} else {
				batch.setSelAfterSeq(start, 1);
				return;
			}
		} else {
			//On ajoute le 1er lien
			if (this.wrapSel && !XA.isCollapsed(ctx.sel)) {
				this.addJmlTag(this._links[0], jml);
				const elt = JML.jmlToDom(jml).documentElement;
				ctx.schemaDom.exportRange({start: ctx.sel.start, end: ctx.sel.end}, elt);
				this.cleanupContentToPaste(ctx, this.linkerRule, elt);
				jml = JML.dom2jml(elt);
			} else {
				const lnk = this._links[0];
				this.addJmlTag(lnk, jml, this.wrapSel ? lnk.itTi || SRC.extractLeafFromUri(lnk.srcUri) : null);
			}
		}
		if (multiPaste) {
			//On insère les liens suivants si la part est en card N.
			for (let i = 1; i < this._links.length; i++) {
				const lnk = this._links[i];
				this.addJmlTag(lnk, jml, this.wrapSel ? lnk.itTi || SRC.extractLeafFromUri(lnk.srcUri) : null);
			}
		}
		if (jml.length > 0) SKMETA.doPasteReplaceSel(jml, ctx, ctx.schemaDom, batch);
	}
}


/**
 * Impl recherche des liens vers des items
 */
export class SkItemSearch implements ISchemaSearch {

	constructor(readonly srcRef: srcRef | null, public maxResults: number) {}

	buildSearchAnnots(skNode: SkNode, annots: ISkAnnot[]): void {
		//console.log("buildSearchAnnots:::", skNode);
		//TODO cache Map skNode.schemaDom.schema._eltPtrItemRulesMap
		const ptrRule = skNode.rule.contentRule.findRule((rule: SkRule) => rule.skMeta instanceof SkMPtrItem);
		if (ptrRule) {
			if (IS_element(skNode.node)) for (const att of skNode.node.attributes) {
				if (ptrRule.structMatch(ENodeType.attribute, att.nodeName)) {
					if (!this.srcRef) {
						annots.push(new SkSearchNodeAnnot(this, att, "Lien vers un item"));
					} else {
						const targetSrc = (skNode.node.ownerDocument as IDocumentInWspHouse)?.srcRefMap?.get(att.nodeValue);
						const targetRef = (targetSrc == null || targetSrc instanceof Promise) ? att.nodeValue : SRC.srcRef(targetSrc);
						if (targetRef === this.srcRef) {
							annots.push(new SkSearchNodeAnnot(this, att, "Lien vers cet item"));
						}
					}
				}
			}
		}
	}
}

// interface ICacheEltPtrItemRulesMap extends Schema {
// 	_eltPtrItemRulesMap: Map<SkRuleNode, >
// }


/**
 * Impl parcours des noeuds commentaires
 */
export class SkCommentSearch implements ISchemaSearch {

	constructor(public opened: boolean, public closed: boolean, public maxResults: number) {}

	buildSearchAnnots(skNode: SkNode, annots: ISkAnnot[]): void {
		for (let ch = skNode.node.firstChild; ch; ch = ch.nextSibling) {
			if (ch.nodeType === ENodeType.comment) {
				if (this.opened && this.closed) {
					annots.push(new SkSearchNodeAnnot(this, ch, "Commentaire"));
				} else {
					const str = ch.nodeValue;
					const start = str.indexOf('<');
					if (start >= 0) {
						const end = str.indexOf('>', start + 1);
						if (end > 0 && str.indexOf('comment', start + 1) === start + 1 && str.lastIndexOf('xmlns="scenari.eu:comment:1.0"', end) > start) {
							//On est bien sur un commentaire structuré.
							const isClosed = str.lastIndexOf('threadClosed="true"', end) > start;
							if (isClosed === this.closed) {
								annots.push(new SkSearchNodeAnnot(this, ch, "Commentaire"));
							}
							continue;
						}
					}
					//Pas un commentaire structuré, on ajoute toujours
					annots.push(new SkSearchNodeAnnot(this, ch, "Commentaire"));
				}
			}
		}
	}
}

export class SwitchPartConverter implements IConverter {
	async convert(src: IConvertSrc): Promise<IConvertDst | null> {
		if (!src.jml) {
			src.jml = [];
			JML.domNode2jml(src.node, src.jml);
		}
		const newC = [] as IJmlSet;
		src.outStruct.createContent(newC);
		const res = src.jml.concat(); //on duplique uniquement le tableau racine src.jml (on part du principe que les sous-objets ne sont pas modifiés, source immutable)
		const tag = res[0] as any;
		const newTag = newC[0] as any;
		if (tag["sc:refUri"]) newTag["sc:refUri"] = tag["sc:refUri"]; //Préservation explicite du lien : peut être écrasé avec la valeur "" si l'att est obligatoire dans newTag.
		res[0] = Object.assign({}, tag, newTag); //on remplace le tag racine et ses éventuels attributs identifiants (role...).
		return {jml: res};
	}
}

CONVERTERLIB.registerConverterFromXml("sc:part", () => new SwitchPartConverter());

/**
 * Partant d'un contenu, racine (une Compo ou node au-dessus) internalise récursivement toutes les parts externalisées listées dans [parts]
 * @param fromSrc srcRef de la source
 * @param root Contenu de la source, Si null, l'item srcRef sera chargé
 * @param parts Map des nodeName des Compoprims en key et liste des localName de ses parts à internaliser.
 * @param cyclesFound Liste de cycles infinis détectés. Passer un tableau vide au départ.
 */
export async function internalizePartsRecursively(fromSrc: srcRef, root: null | Element | Document | DocumentFragment, parts: Dict<string[]>, wsp: Wsp, uiCtx: HTMLElement, cyclesFound: srcRef[][], cycleGuard?: Set<srcRef>): Promise<Element | Document | DocumentFragment> {
	if (cycleGuard == null) cycleGuard = new Set();
	if (!root) {
		const house = wsp.wspServer.wspsLive.getHouseIfFetched(WSP.buildWspRef(wsp.code, fromSrc));
		if (house) {
			root = house.document.documentElement.lastElementChild.cloneNode(true);
			fromSrc = SRC.srcRef(house.srcFields);
		} else {
			const resp = await ITEM.fetchContent(wsp, uiCtx, fromSrc, false, "srcUri*srcId");
			root = new DOMParser().parseFromString(await resp.text(), "text/xml").documentElement.lastElementChild;
			fromSrc = SRC.srcRef(JSON.parse(resp.headers.get("X-SCFIELDS")) as JSrcFields);
		}
	}
	let n = root.firstElementChild;
	while (n) {
		const refUri = n.getAttribute("sc:refUri");
		if (refUri) {
			const compoParts = parts[n.parentNode.nodeName];
			if (compoParts && compoParts.indexOf(n.localName) >= 0) {
				try {
					let eltToImport: Element;
					let srcRefToImport: srcRef;
					const house = wsp.wspServer.wspsLive.getHouseIfFetched(WSP.buildWspRef(wsp.code, refUri));
					if (house) {
						eltToImport = n.ownerDocument.importNode(house.document.documentElement.lastElementChild, true);
						srcRefToImport = SRC.srcRef(house.srcFields);
					} else {
						const resp = await ITEM.fetchContent(wsp, uiCtx, refUri, false, "srcUri*srcId");
						eltToImport = n.ownerDocument.adoptNode(new DOMParser().parseFromString(await resp.text(), "text/xml").documentElement.lastElementChild);
						srcRefToImport = SRC.srcRef(JSON.parse(resp.headers.get("X-SCFIELDS")) as JSrcFields);
					}
					if (cycleGuard.has(srcRefToImport)) {
						cyclesFound.push([...cycleGuard, srcRefToImport]);
					} else {
						cycleGuard.add(srcRefToImport);
						n.removeAttribute("sc:refUri");
						n.appendChild(eltToImport);
						await internalizePartsRecursively(srcRefToImport, eltToImport, parts, wsp, uiCtx, cyclesFound, cycleGuard);
						cycleGuard.delete(srcRefToImport);
						n = DOM.findNextUncle(n, root, IS_element);
						continue;
					}
				} catch (e) {
					console.log("Internalize part failed", e);
				}
			}
		}
		n = DOM.findNext(n, root, IS_element);
	}
	return root;
}